import React, { Component } from "react";
import axios from "axios";
import { Button, Col, Drawer, Form, Input, Space, message, Card } from "antd";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);

function formatCommentDate(dateString) {
    const date = dayjs(dateString);
    if (date.isSame(dayjs(), 'day')) {
        return date.locale('es').fromNow();
    }
    return date.format('DD/MM/YYYY');
}

class CommentsDrawer extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = { text: "" };
        this.handleCloseForm = this.handleCloseForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            this.setState({ text: "" });
            if (this.formRef.current) {
                this.formRef.current.resetFields();
            }
        }
    }

    handleCloseForm() {
        this.setState({ text: "" }, () => {
            if (this.formRef.current) {
                this.formRef.current.resetFields();
            }
            this.props.onClose();
        });
    }

    async handleSubmit() {
        const { text } = this.state;
        try {
            await axios.post(
                "https://backoffice.nadu.xyz/api/sepa-comment/generate",
                {
                    text,
                    sepa_log: this.props.selectedRefund.id,
                    author: this.props.customer,
                },
                {
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_BACKOFFICETOKEN}`,
                    },
                }
            );
            message.success("Se ha creado el comentario");
            this.handleCloseForm();
            this.props.refetch();
        } catch (error) {
            console.error("Error al crear el comentario:", error);
            message.error("Error al crear el comentario");
        }
    }

    render() {
        const { text } = this.state;
        const { open, selectedRefund } = this.props;

        const comments = selectedRefund && selectedRefund.sepa_comments
            ? [...selectedRefund.sepa_comments].sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            )
            : [];
        return (
            <Drawer
                title="Comentarios"
                width={720}
                onClose={this.handleCloseForm}
                open={open}
                destroyOnClose
                afterVisibleChange={(visible) => {
                    if (!visible) {
                        this.setState({ text: "" });
                        if (this.formRef.current) {
                            this.formRef.current.resetFields();
                        }
                    }
                }}
            >
                <Form
                    layout="vertical"
                    hideRequiredMark
                    ref={this.formRef}
                    initialValues={{ text: "" }}
                >
                    <Col span={24}>
                        <Form.Item name="text" label="Comentario">
                            <Input
                                placeholder="Ingresar el comentario"
                                value={text}
                                onChange={(e) => this.setState({ text: e.target.value })}
                            />
                        </Form.Item>
                    </Col>
                    <Space style={{ paddingTop: 8, width: "100%", justifyContent: "flex-end", display: "flex" }}>
                        <Button onClick={this.handleCloseForm}>Cancelar</Button>
                        <Button onClick={this.handleSubmit} type="primary">
                            Crear comentario
                        </Button>
                    </Space>
                </Form>

                <div style={{ marginTop: 20 }}>
                    <h3>Comentarios:</h3>
                    {comments.length > 0 ? (
                        comments.map((comment) => (
                            <Card key={comment.id} title={comment.author && comment.author.name} style={{ marginBottom: 10 }}>
                                <p>{comment.text}</p>
                                <p style={{ justifyContent: "flex-end", display: "flex" }}>
                                    <small>{formatCommentDate(comment.createdAt)}</small>
                                </p>
                            </Card>
                        ))
                    ) : (
                        <p>No hay comentarios disponibles.</p>
                    )}
                </div>
            </Drawer>
        );
    }
}

export default CommentsDrawer;



// WEBPACK FOOTER //
// ./src/views/Bills/components/CommentsDrawer.jsx